import {SurveyTextarea, YesOrNoRadios} from './Survey'
import {AP_SURVEY_GUIDE_EVENT_TYPE_ID, AP_SURVEY_PRVODARCE_EVENT_TYPE_ID} from '../../helpers/misc'
import {AP_SURVEY_QUESTIONS_GUIDE} from "../../helpers/misc_survey"
import {SurveyCards} from "./SurveyCards"

export class SurveyGuideCards extends SurveyCards  {

  state = {
    ...this.getDefaultState(),
    bigQuestions: [6],
    questions: AP_SURVEY_QUESTIONS_GUIDE,
  }

  async componentDidMount() {

    void this.getDataForForm(this.props.type === "guide" ? AP_SURVEY_GUIDE_EVENT_TYPE_ID : AP_SURVEY_PRVODARCE_EVENT_TYPE_ID)
  }

  getItems = ({ gender, questions, setSurveyAnswer, type }) => {
    return [
      {
        header: type === "guide" ? "Dotazník - Průvodka" : "Dotazník - Prvodárce",
        title: <>Vyplněním všech otázek si významně zkrátíte čas, který byste strávili vyplněním otázek v dárcovském centru. Uvedené údaje nejsou povinné. Pokud si nejste u některé z otázek jistí odpovědí, otázku prosím nevyplňujte. Podrobné poučení pro dárce naleznete <a href='https://www.amberplasma.com/file/1144' target='_blank'>zde</a>. Platnost vyplněného dotazníku je 48 hodin, nevyplňujte dříve než 48 hodin před Vašim darováním!</>,
        description: <span className="first-description">Dotazník vám zabere <strong>cca 10 minut.</strong></span>
      },
      {
        className: questions.q1.answer !== undefined ? "step-open-by-default" : null,
        title: gender !== "2" ? questions.q1.question : questions.q1.question_female,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
        </div>
      },
      {
        title: gender !== "2" ? questions.q2.question : questions.q2.question_female,
        className: questions.q2.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q2"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q2.answer === true &&
            <SurveyTextarea skey={"q2z"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          }

        </div>
      },
      {
        title: gender !== "2" ? questions.q3.question : questions.q3.question_female,
        className: questions.q3.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q3"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
        </div>
      },
      {
        title: gender !== "2" ? questions.q4.question : questions.q4.question_female,
        className: questions.q4.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q4"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
        </div>
      },
      {
        title: gender !== "2" ? questions.q5.question : questions.q5.question_female,
        className: questions.q5.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q5"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
        </div>
      },
      {
        title: gender !== "2" ? questions.q6.question : questions.q6.question_female,
        className: (questions.q6?.answer !== undefined ||
          questions.q6a?.answer !== undefined ||
          questions.q6b?.answer !== undefined ||
          questions.q6c?.answer !== undefined ||
          questions.q6d?.answer !== undefined ||
          questions.q6e?.answer !== undefined ||
          questions.q6f?.answer !== undefined ||
          questions.q6g?.answer !== undefined ||
          questions.q6i?.answer !== undefined ||
          questions.q6j?.answer !== undefined
        ) ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <div className="mi-3">
            <label>{gender !== "2" ? questions.q6a?.question : questions.q6a?.question_female}</label>
            <YesOrNoRadios skey={"q6a"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{gender !== "2" ? questions.q6b?.question : questions.q6b?.question_female}</label>
            <YesOrNoRadios skey={"q6b"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{gender !== "2" ? questions.q6c?.question : questions.q6c?.question_female}</label>
            <YesOrNoRadios skey={"q6c"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

            {questions.q6c?.answer === true &&
              <SurveyTextarea skey={"q6cz"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
            }
          </div>
          <div className="mi-3">
            <label>{gender !== "2" ? questions.q6d?.question : questions.q6d?.question_female}</label>
            <YesOrNoRadios skey={"q6d"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{gender !== "2" ? questions.q6e?.question : questions.q6e?.question_female}</label>
            <YesOrNoRadios skey={"q6e"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{gender !== "2" ? questions.q6f?.question : questions.q6f?.question_female}</label>
            <YesOrNoRadios skey={"q6f"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{gender !== "2" ? questions.q6g?.question : questions.q6g?.question_female}</label>
            <YesOrNoRadios skey={"q6g"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

            {questions.q6g?.answer === true &&
              <SurveyTextarea skey={"q6gz"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
            }
          </div>
          <div className="mi-3">
            <label>{gender !== "2" ? questions.q6i?.question : questions.q6i?.question_female}</label>
            <YesOrNoRadios skey={"q6i"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>

          {gender !== "1" &&
            <div className="mi-3">
              <label>{gender !== "2" ? questions.q6j?.question : questions.q6j?.question_female}</label>
              <YesOrNoRadios skey={"q6j"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
            </div>
          }

        </div>
      },
    ]
  }
}